import React from 'react'

const NotFound = () => {
    return (
        <div>
            Sorry, 404 PAGE NOT FOUND
            
        </div>
    )
}

export default NotFound
